import { AuthPort } from '../ports/AuthPort';

export class ResetPasswordUseCase {
  constructor(private authPort: AuthPort) {}

  async execute(newPassword: string): Promise<void> {
    await this.authPort.changePassword(newPassword);
  }
}
